import { render, staticRenderFns } from "./Iconfont.vue?vue&type=template&id=3bf0deda&name=component-name&"
import script from "./Iconfont.vue?vue&type=script&lang=js&"
export * from "./Iconfont.vue?vue&type=script&lang=js&"
import style0 from "./Iconfont.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports